<script>
export default {
  name: 'PromotionsPagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['prev', 'next', 'update-page-size'],
  methods: {
    handlePrevious() {
      if (this.currentPage > 1) {
        this.$emit('prev');
      }
    },
    handleNext() {
      if (this.currentPage < this.totalPages) {
        this.$emit('next');
      }
    },
    handlePageSizeChange(newSize) {
      this.$emit('update-page-size', Number(newSize));
    },
  },
};
</script>

<template>
  <div
    class="flex justify-between items-center mt-4 pt-4 border-t border-slate-200 dark:border-slate-800"
  >
    <div class="flex items-center gap-2">
      <span class="text-sm text-slate-600 dark:text-slate-400">
        Page {{ currentPage }} of {{ totalPages }}
      </span>
      <select
        :value="pageSize"
        @change="handlePageSizeChange($event.target.value)"
        class="text-sm px-2 py-1 border rounded"
        :disabled="isLoading"
      >
        <option value="10">10 per page</option>
        <option value="20">20 per page</option>
        <option value="50">50 per page</option>
        <option value="100">100 per page</option>
      </select>
    </div>

    <div class="flex gap-2">
      <woot-button
        variant="smooth"
        color-scheme="secondary"
        size="small"
        :disabled="currentPage <= 1 || isLoading"
        @click="handlePrevious"
      >
        <fluent-icon icon="chevron-left" size="16" />
        Previous
      </woot-button>

      <woot-button
        variant="smooth"
        color-scheme="secondary"
        size="small"
        :disabled="currentPage >= totalPages || isLoading"
        @click="handleNext"
      >
        Next
        <fluent-icon icon="chevron-right" size="16" />
      </woot-button>
    </div>
  </div>
</template>
